import React from "react";
import Layout from '../../components/Layout'
import ErrorMessage from '../../components/Layout/ErrorMessage'
const AccessAbort = () => {
  

  return (
    <Layout> 
      <iframe
         src="https://rsv-dev.idp360.uhg.com/flumeter?clientid=1&frameid=1"
        title="Infectious Disease Platform"
        width="100%"
        height="500px"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading="lazy" // Optimizes loading performance
      /> 
       <iframe
         src="https://rsv-dev.idp360.uhg.com/about"
        title="Infectious Disease Platform"
        width="100%"
        height="100%"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading="lazy" // Optimizes loading performance
      /> 

    <ErrorMessage
        errorCode={'401'}
        errorMessage={''}
        errorSubject={'UnAuthorized Access'}
        errorDetails={'Requsted email id not authorized to access.'}
      />    
</Layout>
  )

  }

export default AccessAbort;
